import { CButton, CText } from '@carrefour/design-system-components-react';
import styled from 'styled-components';
import { formatCurrency } from '../../utils/numberUtils';

interface AlertHeaderProps {
  backToAlertMenu: () => void;
  impactValue?: number;
  isMobile?: boolean;
  groupName?: string;
  groupIcon?: string;
  showBanner?: boolean;
}

const HeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem;
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const LeftSide = styled.div`
  display: flex;
  align-items: center;
  border-radius: 0.2rem;
  gap: 0.5rem;
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
`;

const CButtonCustom = styled(CButton)`
  backgroundColor: #f7f7f7;
  width: "50px";
  i {
    color: black;
  }
`;

const Banner = styled.div`
  background-color: #E6F1FE;
  padding: 4px 8px;
  border-radius: 4px;
  margin-top: 4px;
  text-align: left;
`;

const AlertHeader: React.FC<AlertHeaderProps> = ({ backToAlertMenu, impactValue, isMobile, groupName, groupIcon, showBanner  }) => {
  return ( 
      <HeaderInfo> 
        <TopRow>
          <LeftSide>
            {isMobile && <CButton variation="tertiary" size="m" appendIcon="chevron-left" onClick={backToAlertMenu}/>}
            <CButtonCustom variation="tertiary" size="m" disabled appendIcon={groupIcon} />
            <CText size="m" bold>{groupName}</CText>
          </LeftSide>
          <RightSide>
            <CText size="m">Impact financier : <strong>{impactValue && impactValue > 0 ? formatCurrency(impactValue) : "Non chiffré"}</strong></CText>
          </RightSide>
        </TopRow>
         { !isMobile && showBanner && 
            <Banner>
               <CText size="s">Les impacts sont chiffrés uniquement sur les indicateurs disposant d'une règle de calcul d'impact validée. <br />
                 <strong>Hors : Satisfaction Clients, NPS, part de marché, E-Commerce (UHP et saturation)</strong></CText>
            </Banner>
            }
      </HeaderInfo>
  );
};

export default AlertHeader;
